import { add, format } from 'date-fns';
import {
  CircularProgress,
  Grid,
  TextField, Typography,
} from '@material-ui/core';
import { useCompany } from 'contexts/CompanyContext';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import DefaultModal from 'components/DefaultModal';

const validationSchema = Yup.object({
  startDate: Yup.date().required('Champ requis'),
  endDate: Yup.date()
    .when(
      'startDate',
      (startDate, schema) =>
        startDate && schema.min(startDate, 'La date de fin doit être après la date de début'),
    )
    .required('Champ requis'),
}).defined();

export default function PeriodModal({ open, onCancel, onSubmit }) {
  const { currentCompany } = useCompany();

  const { errors, handleChange, isSubmitting, submitForm, touched, values } = useFormik({
    validationSchema,
    initialValues: {
      startDate: format(new Date(), 'yyyy-MM-dd'),
      endDate: format(add(new Date(), { months: 1 }), 'yyyy-MM-dd'),
    },
    onSubmit: async (values) => {
      if (!currentCompany) return;
      await onSubmit?.(values);
    },
  });

  function handleCancel() {
    if (isSubmitting) return;
    onCancel?.();
  }

  return (
    <DefaultModal
      confirmButtonText={isSubmitting ? <CircularProgress size={20} /> : 'Valider'}
      disableConfirm={isSubmitting}
      forceConfirm
      open={open}
      title="Propagation de l'agenda"
      onClose={handleCancel}
      onConfirm={submitForm}
    >
      <Grid container justifyContent='space-around' spacing={2}>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Typography>
            Bravo! Votre agenda hebdomadaire est désormais paramètré. Définissez une période
            pour l’activer.
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <TextField
            error={touched.startDate && Boolean(errors.startDate)}
            helperText={touched.startDate && errors.startDate}
            fullWidth
            label='Début'
            name='startDate'
            type='date'
            value={values.startDate}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            error={touched.endDate && Boolean(errors.endDate)}
            helperText={touched.endDate && errors.endDate}
            fullWidth
            label='Fin'
            name='endDate'
            type='date'
            value={values.endDate}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </DefaultModal>
  )
}
